<template>
  <div class="list">
    <Chip
      v-for="tag in newList"
      :tag="tag"
    />
    <div
      v-if="isViewMore"
      class="more"
      @click="viewMore"
    >
      Ещё
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, computed } from 'vue';

  import { useScreenSize } from '@/shared/lib';
  import { type TagWithActive } from '@/shared/models';
  import Chip from '@/shared/ui/Chip.vue';

  const maxCount = 26;
  const viewFull = ref(false);
  const { isMobile } = useScreenSize();

  interface Props {
    list: TagWithActive[];
  }

  const props = defineProps<Props>();

  const isViewMore = computed(() => {
    return props.list?.length > maxCount && !viewFull.value && !isMobile.value;
  });

  const newList = computed(() => {
    return isViewMore.value ? props.list?.slice(0, maxCount - 1) : props.list;
  });

  const viewMore = () => {
    viewFull.value = !viewFull.value;
  };
</script>

<style lang="scss" scoped>
  @use '@experience/shared/dist/assets/adaptivity';

  .list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 16px;

    @include adaptivity.mobile {
      flex-wrap: nowrap;
      overflow-x: scroll;
      margin-top: 8px;
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  }

  .more {
    padding: 6px 12px;
    border: 1px solid var(--comp-radiobutton-color-border);
    border-radius: 8px;
    cursor: pointer;
  }
</style>
